module.exports = __webpack_public_path__ + "arrow.svg?12b2278cf3635af6c5bc6faf8d4eb3d6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.svg
// module id = 16
// module chunks = 0